import { prepareOptionsForDropDown } from 'dedicated/services/summary.service';
import { emailValidaotr, mandatoryFieldValditor, mobileValidator, pinCodeValidator } from '../../../../common/utils/validator';
import { ADDRESS_TYPE_ENUM, formElement } from '../summary.constant';

export const BILLING_TYPES_IDs = {
  NEW: 'NEW',
  EXISTING: 'EXISTING'
};

export const BILLING_TYPES = [
  { id: BILLING_TYPES_IDs.EXISTING, displayName: 'Existing Billing Details' },
  { id: BILLING_TYPES_IDs.NEW, displayName: 'New Billing Details' }
];

export const billableIdFormKey = 'billableId';
export const keysToIgnoreForExistingAddress = ['city', 'address', 'email', 'mobileNumber', 'pinCode', 'personName', 'poId'];
export const formSchema = {
  type: { id: 'accountLevel', displayName: 'Account Level' },
  paymentType: '',
  paymentCycle: '',
  companyName: '',
  pinCode: { ...formElement, validator: pinCodeValidator },
  city: { ...formElement },
  address: { ...formElement, validator: mandatoryFieldValditor },
  personName: { ...formElement, validator: mandatoryFieldValditor },
  mobileNumber: { ...formElement, validator: mobileValidator },
  email: { ...formElement, validator: emailValidaotr },
  selected: { ...formElement, value: BILLING_TYPES[0] },
  [billableIdFormKey]: { ...formElement, validator: mandatoryFieldValditor },
  accountNumber: { ...formElement },
  poId: { ...formElement }
};

export const accountDetailSchema = {
  companyName: '',
  accountNumber: '',
  parentAccountNumber: '',
  rootAccountNumber: '',
  gstNumber: '',
  gstSez: '',
  billingType: '',
  billingCycle: '',
  billingAddress: {
    pincode: '',
    state: '',
    city: '',
    addressLine1: '',
    addressLine2: ''
  },
  contacts: [
    {
      contactId: '',
      contactType: '',
      firstName: '',
      lastName: '.',
      middleName: '',
      designation: '',
      email: '',
      phoneNumber: ''
    }
  ],
  billable: true
};

const setBCP = (billingContactDetails) => {
  if (billingContactDetails) {
    formSchema.email.value = billingContactDetails.email || '';
    formSchema.mobileNumber.value = billingContactDetails.phoneNumber || '';
    formSchema.personName.value = billingContactDetails.firstName || '';
  }
};

const setAccountAndBillableId = (bcpId, { crmNbaId }) => {
  formSchema.accountNumber = { ...formSchema.accountNumber, value: crmNbaId ? { displayName: crmNbaId, key: crmNbaId } : formSchema.accountNumber?.value };
  formSchema.billableId = { ...formSchema.billableId, value: bcpId || '' };
};

const setBillingTypesAndPayment = ({ billingCycle, billingType }) => {
  const billingTypeOptions = prepareOptionsForDropDown(['Advance', 'Arrear'], null, null, 'Billing');
  const billingTypeValue = billingType ? billingTypeOptions.find(({ key }) => key === billingType) : billingTypeOptions[0];
  const billingPaymentCycleOptions = prepareOptionsForDropDown(['Quarterly', 'Monthly', 'Half-yearly', 'Annually']);
  const billingPaymentCycleValue = billingCycle ? billingPaymentCycleOptions.find(({ key }) => key === billingCycle) : billingPaymentCycleOptions[0];
  formSchema['paymentType'] = { ...formElement, value: billingTypeValue, options: billingTypeOptions };
  formSchema['paymentCycle'] = { ...formElement, value: billingPaymentCycleValue, options: billingPaymentCycleOptions };
};

export const getDefaultValue = (order) => {
  const {
    billingLevel,
    billingAddress,
    parentAccountNumber,
    billingContactDetails,
    companyAddress: { addressLine1 },
    lead: { customer }
  } = order;
  const poId = order?.lead?.connectivityLineItems?.[0]?.poId;
  let cityObj = {};
  cityObj.displayName = billingAddress && billingAddress.city;
  cityObj.key = billingAddress && billingAddress.city;
  formSchema['type'] = getBillingOptionById(billingLevel);
  setBillingTypesAndPayment(order);
  //  formSchema['addressType']['existingAddress'] = addressLine1;
  formSchema['companyName'] = customer && customer.authorizedSignatory && customer.authorizedSignatory.companyName;
  formSchema.pinCode.value = billingAddress && billingAddress.pincode ? billingAddress.pincode : '';
  formSchema.pinCode.touched = true;
  formSchema.address.value =
    billingAddress && billingAddress.addressLine1 ? billingAddress.addressLine1 + (billingAddress.addressLine2 ? ` ${billingAddress.addressLine2}` : '') : '';
  formSchema.city.value = cityObj;
  setBCP(billingContactDetails);
  setAccountAndBillableId(billingContactDetails?.address?.m6Id, customer);
  formSchema.poId = { ...formSchema.poId, value: { key: poId, displayName: poId, value: poId } ?? { key: 'New', displayName: 'New', value: 'New' } };
  formSchema['selected'] = { ...formSchema['selected'], value: billingContactDetails?.address?.m6Id ? BILLING_TYPES[0] : BILLING_TYPES[1] };

  return formSchema;
};

export const billingTypeOption = [
  { id: 'ACCOUNT', displayName: 'Account Level' },
  { id: 'PO', displayName: 'PO Level' },
  { id: 'LSI', displayName: 'Circuit level' }
];

export const getBillingOptionById = (billingLevel) => {
  return billingTypeOption.filter(({ id }) => id === billingLevel)[0];
};

export const mapToFormSchema = (bcpDetails, order) => {
  return {
    billingContactDetails: {
      ...order?.billingContactDetails,
      email: bcpDetails.emailAddress,
      phoneNumber: bcpDetails.phoneNumber,
      firstName: bcpDetails.firstName
    },
    billingAddress: {
      ...bcpDetails,
      address: bcpDetails?.addressLine1 ? bcpDetails.addressLine1 + (bcpDetails.addressLine2 ? ` ${bcpDetails.addressLine2}` : '') : ''
    }
  };
};

export const getBCPOptions = (options, searchValue) => {
  if (!searchValue) {
    options.slice(0, 40);
  }
  return options
    .filter((option) => {
      return option.value.includes(searchValue);
    })
    .slice(0, 40);
};
